

export const MAIN_ROUTE = '/';
export const ENGLISH_MAIN_ROUTE = '/en';

export const ES_SERVICE = '/servicio';
export const ES_TECHNOLOGY = '/tecnologia';
export const ES_PRICES = '/tarifa';
export const ES_RESOURCES = '/recursos';
export const ES_US = '/conocenos';
export const ES_CONTACT = '/contacto';
export const ES_LEGAL_TEXT = '/aviso-legal';

export const EN_SERVICE = '/service';
export const EN_TECHNOLOGY = '/technology';
export const EN_PRICES = '/fee';
export const EN_RESOURCES = '/resources';
export const EN_US = '/meet-us';
export const EN_CONTACT = '/contact';
export const EN_LEGAL_TEXT = '/legal-text';
export const LANDING_CONTACT_NOW = 'contacta-ahora';
export const LANDING_QUICK_CONTACT = 'contacto-rapido';

export const ES_LOGIN_OWNERS = '/propietarios/login';
export const EN_LOGIN_OWNERS = '/properties/login';

